const trackSegments = {
    tier: [27, 13, 36, 11, 30, 8, 23, 10, 5, 24, 16, 33],
    orphelins: [1, 20, 14, 31, 9, 6, 34, 17],
    voisins: [22, 18, 29, 7, 28, 25, 2, 21, 4, 19, 12, 35, 3, 26, 0, 32, 15],
    zero: [12, 35, 3, 26, 0, 32, 15]
}

const trackSegmentsPlace = {
    tier: [{ p: "5-8", m: 1 }, { p: "10-11", m: 1 }, { p: "13-16", m: 1 }, { p: "23-24", m: 1 }, { p: "27-30", m: 1 }, { p: "33-36", m: 1 }],
    orphelins: [{ p: "1", m: 1 }, { p: "6-9", m: 1 }, { p: "14-17", m: 1 }, { p: "17-20", m: 1 }, { p: "31-34", m: 1 }],
    voisins: [{ p: "0-2-3", m: 2 }, { p: "4-7", m: 1 }, { p: "12-15", m: 1 }, { p: "18-21", m: 1 }, { p: "19-22", m: 1 }, { p: "25-26-28-29", m: 2 }, { p: "32-35", m: 1 }],
    zero: [{ p: "0-3", m: 1 }, { p: "12-15", m: 1 }, { p: "26", m: 1 }, { p: "32-35", m: 1 }]
}

const track = [27, 13, 36, 11, 30, 8, 23, 10, 5, 24, 16, 33, 1, 20, 14, 31, 9, 22, 18, 29, 7, 28, 12, 35, 3, 26, 0, 32, 15, 19, 4, 21, 2, 25, 17, 34, 6]

const getNeighbours = (number, neighbourCnt) => {

    const index = track.indexOf(number)
    if (index === -1) return []

    const total = track.length;
    const neighbours = [number]

    for (let i = 1; i <= neighbourCnt; i++) {
        const left = track[(index - i + total) % total]
        const right = track[(index + i) % total]
        neighbours.push(left, right)
    }

    return neighbours;
}

const getHoveredList = (hoveredRace, neighbourCnt) => {

    let list = []

    if (hoveredRace || hoveredRace === 0) {
        if (trackSegments[hoveredRace]) {
            list = trackSegments[hoveredRace]
        } else {
            list = getNeighbours(hoveredRace, neighbourCnt)
        }
    }

    return list

}

const getHoveredListPlaces = (hoveredRace, neighbourCnt) => {

    let list = []

    if (hoveredRace && trackSegmentsPlace[hoveredRace]) {
        list = trackSegmentsPlace[hoveredRace]
    } else {
        const demoList = getNeighbours(hoveredRace, neighbourCnt)
        list = demoList.map(e => ({ p: String(e), m: 1 }))
    }

    return list
}

export { trackSegments, track, trackSegmentsPlace, getNeighbours, getHoveredList, getHoveredListPlaces }